/* eslint-disable camelcase */
import { Cart, ICart } from './typings';

const assignRemainingAvailablities = (cartState: Cart, variantsAtLimit: string[]) : ICart => ({
  ...cartState,
  items: cartState.items.map(item => {
    const variant_id = item.variant_id.toString()
    return {
      ...item,
      availablity_remaining: !variantsAtLimit.includes(variant_id)
    }
  })
})
export default assignRemainingAvailablities;